var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{staticClass:"red--text",on:{"click":function($event){return _vm.handleRemove()}}},[_vm._v("Delete Invoice")])
}
var staticRenderFns = []

export { render, staticRenderFns }